import { createContext } from 'react';
import { IDeleteApkFirmwareValidationError, IServerError, IApk, TApkType } from 'types';

export type TApkSortBy =
	| ''
	| 'VersionName1-10'
	| 'VersionName10-1'
	| 'DescriptionA-Z'
	| 'DescriptionZ-A'
	| 'ApplicationId1-10'
	| 'ApplicationId10-1';
export type TCountOfApk = '12' | '24' | '48';
export type TTypeOfModalWindow = null | 'toConfirmDeleteItem' | 'success' | 'error';
export interface IFilterValues {
	searchString: string;
	IDSelectedApkType: Nullable<TApkType>;
	isUnassignedApk: boolean;
	sortBy: TApkSortBy;
	countOfItems: TCountOfApk;
	currentPage: number;
}

export interface IApkState {
	apk: IApk;
	searchString: string;
	IDSelectedApkType: Nullable<TApkType>;
	isUnassignedApk: boolean;
	sortBy: TApkSortBy;
	countOfItems: TCountOfApk;
	currentPage: number;
	apkIDForDeletion: string;
	typeOfModalWindow: TTypeOfModalWindow;
	errorResponseData: IServerError<IDeleteApkFirmwareValidationError> | null;
}

export const apkInitialState: IApkState = {
	apk: { count: 0, items: [] },
	searchString: '',
	IDSelectedApkType: null,
	isUnassignedApk: false,
	sortBy: '',
	countOfItems: '12',
	currentPage: 1,
	apkIDForDeletion: '',
	typeOfModalWindow: null,
	errorResponseData: null,
};

export interface IApkContext extends IApkState {
	deleteSelectedItem(): void;
	changeSearchString(value: string): void;
	setIDApkType(value: Nullable<TApkType>): void;
	toggleUnassignedApk(): void;
	resetSelectedControls(): void;
	setSortBy(sortBy: TApkSortBy): void;
	setCountOfItems(count: TCountOfApk): void;
	changeCurrentPage(page: number): void;
	setApkIDForDeletion(apkID: string | null): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	setFiltersFromQueryString(value: IFilterValues): void;
	showErrorModalWithInfo(value: IServerError<IDeleteApkFirmwareValidationError> | null): void;
}

export const ApkContext = createContext<IApkContext>({
	deleteSelectedItem: () => undefined,
	changeSearchString: () => undefined,
	setIDApkType: () => undefined,
	toggleUnassignedApk: () => undefined,
	resetSelectedControls: () => undefined,
	setSortBy: () => undefined,
	setCountOfItems: () => undefined,
	changeCurrentPage: () => undefined,
	setApkIDForDeletion: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	setFiltersFromQueryString: () => undefined,
	showErrorModalWithInfo: () => undefined,
	...apkInitialState,
});
